/**
 * Lets non-sprint saves (Docs folder org, etc.) drive the same
 * top-right Saving / Saved indicator as campaign flow.
 */
export const SAVE_INDICATOR_EVENT = 'fokus:save-indicator';

/** @param {'idle' | 'saving' | 'saved'} status */
export function reportSaveStatus(status) {
  window.dispatchEvent(
    new CustomEvent(SAVE_INDICATOR_EVENT, { detail: { status } })
  );
}
